import apiClient from '@/api/client';

export const PartnerAuditLogService = {
    async getAll(name: string, id: string): Promise<PartnerEntityAuditLogsResponse> {
        const response = await apiClient.get<PartnerEntityAuditLogsResponse>(`/partner/audit-logs/${name}/${id}`);
        const result = response.data

        if (response.status != 200) {
            throw new Error('Failed to retrieve audit logs.');
        }

        return result;
      }
}

export interface PartnerEntityAuditLogsResponse {
    logs: AuditLog[]
}

export interface AuditLog {
  id: string
  entityName: string
  entityId: string
  action: string
  changedBy?: string | null
  changedAtUtc: string
  oldValues?: string | null
  newValues?: string | null
  changedProperties?: string | null
  channelPartnerId: number
  channelPartnerName?: string | null
}